export default __webpack_public_path__ + "static/media/iread_22_2.a5205707.jpg";